import React, { useState, useEffect } from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { useForm } from 'react-hook-form';

import { Message } from 'components/shared';
import Container from 'components/Container';
import PasswordInput from 'components/Login/components/PasswordInput';
import TitanLogoImage from 'assets/images/authentication/titan-logo.png';
import AuthHeaderImage from 'assets/images/authentication/auth-image.png';
import { useHistory } from 'react-router-dom';
import useResetPassword from './ResetPasswordUtility/useResetPassword';

const useStyles = makeStyles(() => ({
  heading: {
    fontSize: '14px',
    fontWeight: '600',
    letterSpacing: 0,
    marginTop: '14px'
  },
  displayFlex: {
    display: 'flex'
  },
  loginButton: {
    textTransform: 'none',
    padding: '10px 13px',
    fontSize: '14px',
    marginTop: '26px'
  }
}));

const ResetPassword = () => {
  const [state, resetPassword, getResetId] = useResetPassword();
  const { isLoading, isError, error, data } = state;
  const [password, setPassword] = useState('');
  const [repeatedPassword, setRepeatedPassword] = useState('');
  const [hasError, setHasError] = useState(false);

  const { handleSubmit } = useForm();

  const history = useHistory();
  const { location } = history;

  const handlePasswordChange = event => {
    setPassword(event.target.value);
  };

  const handleRepeatedPasswordChange = event => {
    setRepeatedPassword(event.target.value);
  };

  const handleForgottenPasswordClick = () => {
    if (password === repeatedPassword) {
      resetPassword(password, getResetId(location.search));
    }
  };

  useEffect(() => {
    if (isLoading) {
      return;
    }
    if (isError) {
      setHasError(true);
    }
    if (data !== undefined) {
      setTimeout(() => {
        history.push('/');
      }, 3000);
    }
  }, [isLoading, isError, data, history]);

  const renderMessage = () => {
    if (password !== repeatedPassword) {
      if (hasError) {
        setHasError(false);
      }
      return <Message type="error" text="Passwords do not match" />;
    }
    if (hasError) {
      return <Message type="error" text={error} />;
    }

    if (data !== undefined) {
      return <Message type="success" text="Successfully changed password! " />;
    }
  };

  const classes = useStyles();
  return (
    <Container size={100} center background="#346C9F">
      <Grid container direction="row" alignItems="center" justify="center">
        <Grid item xs={12} md={4}>
          <Box
            component="img"
            src={TitanLogoImage}
            alt="alt"
            display="flex"
            maxWidth="100%"
            pb={2}
            px={3}
          />
          <Box width="100%" bgcolor="#fff" borderRadius="4px">
            <Box component="img" src={AuthHeaderImage} alt="alt" display="flex" maxWidth="100%" />
            <Box p={3}>
              <Typography variant="subtitle2">Reset your password</Typography>
              <Typography variant="subtitle2" className={classes.heading}>
                Password:
              </Typography>
              <form onSubmit={handleSubmit(handleForgottenPasswordClick)}>
                <PasswordInput
                  fullWidth
                  defaultValue={password}
                  required
                  onChange={handlePasswordChange}
                  margin="dense"
                />
                <Typography variant="subtitle2" className={classes.heading}>
                  Repeat Password:
                </Typography>
                <PasswordInput
                  defaultValue={repeatedPassword}
                  required
                  onChange={handleRepeatedPasswordChange}
                  margin="dense"
                />
                <Box>{renderMessage()}</Box>
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  className={classes.loginButton}
                  type="submit"
                >
                  Reset Password
                </Button>
              </form>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
};

export default ResetPassword;
